import React from 'react';
import { IframeContainer, IframeDisclaimer } from './index.style';
import { Link } from 'react-router-dom';

const botSrc = (code, source, lead, sourceName) => {
    return !sourceName ?
        `//bot.frontcld.com/bot/chat/${code}/?--leadsrc--=${source}&--refid--=${lead}` :
        `//bot.frontcld.com/bot/chat/${code}/?--leadsrc--=${source}&--refid--=${lead}&--url--=${sourceName}`;
};
export const BotIframe = ({ code, source, lead, sourceName }) => (<IframeContainer>
    <iframe
        title='chatbot'
        src={botSrc(code, source, lead, sourceName)}
        frameBorder='0'
        width='100%'
        height='90%'
    />
    <IframeDisclaimer>
        השארת פרטים מהווה אישור לפניה בדיוור ישיר ואישור <Link to='/terms' target='_blank'>תקנון</Link> האתר.
    </IframeDisclaimer>
</IframeContainer>);